import { useState, useEffect } from 'react'; 
import { query as q } from 'faunadb'; 

export default function AdminPanel({ className, db_client, setAdminMode }) {
    const [quotes, setQuotes] = useState([]); 
    const [isLoading, setIsLoading] = useState(true); 
    const [isError, setIsError] = useState(false); 

    useEffect(() => {
        db_client.query(
            q.Map(
                q.Paginate(q.Documents(q.Collection('suggestions'))),
                q.Lambda(x => q.Get(x))
            )
        ).then(ret => {
            console.log(ret); 
            setQuotes(ret.data); 
            setIsLoading(false); 
        }
        ).catch(err => {
            console.log(err); 
            setIsError(true); 
            setIsLoading(false); 
        }); 
    }, [db_client]); 

    const handleDeleteQuote = id => {
        db_client.query(
            q.Delete(q.Ref(q.Collection('suggestions'), id))
        ).then(ret => {
            setQuotes(quotes.filter(quote => quote.ref.id !== id)); 
        }).catch(err => console.log(err)); 
    }; 

    const handleApproveQuote = id => {
        // move document from suggestions to quotes collection 
    }; 

    return (
        <div className={className}>
            <label tabIndex={0} htmlFor="admin-panel" className="p-1 justify-center items-center h-14 w-14 btn btn-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                    <path fillRule="evenodd" d="M12.516 2.17a.75.75 0 00-1.032 0 11.209 11.209 0 01-7.877 3.08.75.75 0 00-.722.515A12.74 12.74 0 002.25 9.75c0 5.942 4.064 10.933 9.563 12.348a.749.749 0 00.374 0c5.499-1.415 9.563-6.406 9.563-12.348 0-1.39-.223-2.73-.635-3.985a.75.75 0 00-.722-.516l-.143.001c-2.996 0-5.717-1.17-7.734-3.08zm3.094 8.016a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clipRule="evenodd" />
                </svg>
            </label>
            <input type="checkbox" id="admin-panel" className="modal-toggle" /> 
            <label htmlFor="admin-panel" className="modal">
                <label className="misn-h-[80vh] modal-box relative" htmlFor="">
                    <label htmlFor="admin-panel" className="absolute top-2 right-2 btn btn-sm btn-square">✕</label> 
                    <h3 className="mb-3 text-lg font-bold">Admin Panel</h3> 
                    <div className="flex flex-col items-center justify-center gap-3">
                        <div className="min-h-[250px] max-h-[250px] w-11/12 overflow-auto">
                            { isLoading ? 
                                <div role="status">
                                    <svg aria-hidden="true" class="mr-2 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-secondary" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                    </svg>
                                    <span class="sr-only">Loading...</span>
                                </div>
                            : "" } 
                            { isError ? 
                                <div className="alert alert-error shadow-lg">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                                        <p>There was an error loading the quotes.</p> 
                                    </div>
                                </div> 
                            : "" } 
                            { quotes.length > 0 && !isLoading ? 
                                <div className="mdy-20 flex flex-col gap-3">
                                    { quotes.map(quote => {
                                        return (
                                            <div tabIndex={0} className="relative collapse bg-slate-600 bg-opacity-20 focus:bg-slate-600 focus:bg-opacity-5 rounded-box transition-all">
                                                <div className="absolute right-2 mt-[0.375rem] flex items-center gap-3">
                                                    <button className="btn btn-square hover:btn-success" onClick={() => handleApproveQuote(quote.ref.id)}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" /> 
                                                        </svg> 
                                                    </button>
                                                    <button className="btn btn-square hover:btn-error" onClick={() => handleDeleteQuote(quote.ref.id)}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                                        </svg>
                                                    </button>
                                                </div> 
                                                <div className="collapse-title text-xl font-medium"><div className="w-3/4">{quote.data.quote}</div></div>
                                                <div className="collapse-content flex flex-col gap-3 animate-none no-animation">
                                                    <p>Created: {new Date(quote.ts).toString()}</p> 
                                                    <p>Rating Average: {quote.data.ratingAvg}</p> 
                                                    <p>Rating Count: {Object.keys(quote.data.ratings).length}</p> 
                                                    <p>Quote ID: {quote.ref.id}</p> 
                                                </div> 
                                            </div> 
                                        ); 
                                    })} 
                                </div> 
                                : "" } 
                        </div>
                        <button className="ml-auto btn btn-primary z-10" onClick={() => setAdminMode(false)}>Logout</button> 
                    </div> 
                </label>
            </label>
        </div>
    ); 
} // written by CoPilot. WTF. 